import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { listarActividades } from "../api/General";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";
import { isInvalid } from "../utils/forms";
import "./css/components.css";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import TypeaheadField from "./controls/TypeaheadField";
import TextareaField from "./controls/TextareaField";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";

function actividadLabel(actividad) {
  return !!actividad && `(${actividad.codigo}) - ${actividad.nombre}`;
}

export default function ActividadForm({ ...props }) {
  const { tramite } = useTramite();
  const formularioTramite = useFormikContext();
  const actividadesCatalog = useCatalog(
    ["actividades", "habilitadas"],
    () => listarActividades({ habilitada: true }),
  );
  const loading = actividadesCatalog.loading;
  const { t } = useTranslation();
  const handleActividadPrincipalChange = (event) => {
    formularioTramite.handleChange(event);
  };
  const handleActividadSecundariaChange = (event) => {
    formularioTramite.handleChange(event);
  };
  const handleDescripcionActividadChange = (event) => {
    formularioTramite.handleChange(event);
  };
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={12}>
            <TypeaheadField
              id="actividadPrincipal"
              name="actividadPrincipal"
              label={t("tramite.actividadPrincipal")}
              value={formularioTramite.values.actividadPrincipal}
              options={actividadesCatalog.data?.filter(
                (actividad) =>
                  actividad.codigo !==
                  formularioTramite.values.actividadSecundaria?.codigo,
              )}
              labelAttr={actividadLabel}
              valueAttr="codigo"
              emptyLabel="..."
              onChange={handleActividadPrincipalChange}
              isInvalid={isInvalid("actividadPrincipal", formularioTramite)}
              error={t(formularioTramite.errors.actividadPrincipal)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TypeaheadField
              id="actividadSecundaria"
              name="actividadSecundaria"
              label={t("tramite.actividadSecundaria")}
              value={formularioTramite.values.actividadSecundaria}
              options={actividadesCatalog.data?.filter(
                (actividad) =>
                  actividad.codigo !==
                  formularioTramite.values.actividadPrincipal?.codigo,
              )}
              labelAttr={actividadLabel}
              valueAttr="codigo"
              emptyLabel="..."
              onChange={handleActividadSecundariaChange}
              isInvalid={isInvalid("actividadSecundaria", formularioTramite)}
              error={t(formularioTramite.errors.actividadSecundaria)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextareaField
              id="descripcionActividad"
              name="descripcionActividad"
              label={t("tramite.descripcionActividad")}
              value={formularioTramite.values.descripcionActividad}
              onChange={handleDescripcionActividadChange}
              rows={12}
              isInvalid={isInvalid("descripcionActividad", formularioTramite)}
              error={t(formularioTramite.errors.descripcionActividad)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
